import {
  AttachmentMimeType,
  OrderMetadataSegment,
} from '@/screens/order-inbounds/types';

export const IMAGE_MAP_MIN_ZOOM = 1;
export const IMAGE_MAP_MAX_ZOOM = 4;

export const REPORT_CONTENT_HEIGHT_EVENT = 'REPORT_CONTENT_HEIGHT';

export const REPORT_HTML_HAS_NO_CONTENT_EVENT = 'REPORT_HTML_HAS_NO_CONTENT';

export const ATTACHMENT_HTML_SEARCH_INPUT_CLICK_EVENT =
  'ATTACHMENT_HTML_SEARCH_INPUT_CLICK_EVENT';

export const INLINE_IMAGE_CLICK_EVENT = 'INLINE_IMAGE_CLICK_EVENT';

export const ATTACHMENT_IMAGE_AREA_CLICK_EVENT =
  'ATTACHMENT_IMAGE_AREA_CLICK_EVENT';

export const UPDATE_IMAGE_HIGHLIGHT_SELECTION_EVENT =
  'UPDATE_IMAGE_HIGHLIGHT_SELECTION';

export const IMAGE_HIGHLIGHT_ERROR_EVENT = 'IMAGE_HIGHLIGHT_ERROR';

export const UPDATE_HTML_HIGHLIGHT_SELECTION_EVENT =
  'UPDATE_HTML_HIGHLIGHT_SELECTION';

export interface ImageMapArea {
  // List of [x, y] coordinates
  coordinates: [number, number][];
  id: string;
}

interface InboundAttachmentBase {
  mimeType: AttachmentMimeType;
  originalFilename?: string;
  url: string;
}

export interface InboundHTMLAttachment extends InboundAttachmentBase {
  type: 'HTML';
}

export interface InboundImageMapAttachment extends InboundAttachmentBase {
  areas: ImageMapArea[];
  type: 'IMAGE_MAP';
}

export interface InboundEmlAttachment extends InboundAttachmentBase {
  type: 'EML';
}

export interface InboundInlineImageAttachment extends InboundAttachmentBase {
  inboundContentId: string;
  type: 'INLINE_IMAGE';
}

export interface InboundAudioAttachment extends InboundAttachmentBase {
  attachmentIndex: number;
  type: 'AUDIO';
}

export type InboundAttachment =
  | InboundHTMLAttachment
  | InboundImageMapAttachment
  | InboundEmlAttachment
  | InboundInlineImageAttachment
  | InboundAudioAttachment;

export interface AttachmentListProps {
  attachments: InboundAttachment[];
  imageHighlights?: Record<string, ImageMapArea[]>;
  onAreaSelect: (area: ImageMapArea) => void;
  onEmlError?: () => void;
  onHighlightElementSelect: (searchInputUUID: string) => void;
  onHtmlHasNoContent?: () => void;
  onInlineImageClick?: (inboundContentId: string) => void;
  orderUUID: string;
  segments?: OrderMetadataSegment[];
  selectedAreaID: string;
  showHighlights?: boolean;
  showTranslations?: boolean;
}

export interface HTMLDisplayProps {
  htmlContent: string;
  imageHighlights?: Record<string, ImageMapArea[]>;
  inlineAttachments?: InboundInlineImageAttachment[];
  maxHeight?: number;
  onAreaSelect?: (area: ImageMapArea) => void;
  onHighlightElementSelect?: (searchInputUUID: string) => void;
  onHtmlHasNoContent?: () => void;
  onInlineImageClick?: (inboundContentId: string, index: number) => void;
  selectedSearchInputUUID?: string;
  showHighlights?: boolean;
  width: number;
  zoomLevel?: number;
}

export interface AttachmentListEMLProps {
  emlAttachment: InboundEmlAttachment;
  imageHighlights?: Record<string, ImageMapArea[]>;
  inlineAttachments?: InboundInlineImageAttachment[];
  onAreaSelect?: (area: ImageMapArea) => void;
  onEmlError?: () => void;
  onHighlightElementSelect: (searchInputUUID: string) => void;
  onHtmlHasNoContent?: () => void;
  onInlineImageClick?: (inboundContentId: string, index: number) => void;
  selectedSearchInputUUID?: string;
  showHighlights?: boolean;
  width: number;
}
